import React from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';

// `replace` drops the dead URL from history; empty splat falls back to `emptyTo`.
const LegacyPrefixRedirect = ({ to, emptyTo }: { to: string; emptyTo?: string }): React.ReactElement => {
  const { search, hash } = useLocation();
  const splat = useParams()['*'] ?? '';
  const target = splat ? `${to}/${splat}${search}${hash}` : `${emptyTo ?? `${to}/`}${search}${hash}`;

  return <Navigate replace to={target} />;
};

export default LegacyPrefixRedirect;
